import { ReactNode, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { ErrorBoundary } from '@components/ErrorBoundary';
import { Prefetch } from '@components/Prefetch';
import { RequireAuth } from '@components/RequireAuth';
import { DatasetDeleteProvider } from '@contexts/DatasetDelete';
import { Content } from '@components/Content';
import { TopBar } from '@components/TopBar';
import { useIdentifyToChatlio } from '@hooks';
import { Loading } from '@components/Loading';
import { Banner } from '@components/TopBar/Banner';
import { Sidebar } from '@shared/components/sidebar';

export type LayoutProps = {
  children?: ReactNode;
};
export function Layout({ children }: LayoutProps) {
  useIdentifyToChatlio();

  return (
    <ErrorBoundary>
      <RequireAuth>
        <Prefetch />
        <DatasetDeleteProvider>
          <Sidebar>
            <Banner />
            <ErrorBoundary>
              <Content>
                <Suspense fallback={<Loading />}>
                  <Outlet />
                  {children}
                </Suspense>
              </Content>
            </ErrorBoundary>
          </Sidebar>
        </DatasetDeleteProvider>
      </RequireAuth>
    </ErrorBoundary>
  );
}
